import {createApp} from "vue";
import EmployeeProvider from "./employees/components/EmployeeProvider.vue";
import LocationFilter from "./employees/components/LocationFilter.vue";
import DepartmentsFilter from "./employees/components/DepartmentsFilter.vue";
import EmployeeSlider from "./employees/components/EmployeeSlider.vue";

createApp({})
    .component("EmployeeProvider", EmployeeProvider)
    .component("LocationFilter", LocationFilter)
    .component("DepartmentsFilter", DepartmentsFilter)
    .component("EmployeeSlider", EmployeeSlider)
    .mount('.employees-module');


document.addEventListener("DOMContentLoaded", function () {
    // open caption on touch displays
    document.querySelectorAll('figcaption .icon-info').forEach(icon => {
        icon.addEventListener('click', function (e) {
            e.stopPropagation(); // prevent bubbling to figure
            const figcaption = icon.closest('figcaption');
            if (figcaption) {
                figcaption.classList.add('show-mobile');
            }
        });
    });
    document.querySelectorAll('figcaption .icon-close').forEach(icon => {
        icon.addEventListener('click', function (e) {
            e.stopPropagation();
            const figcaption = icon.closest('figcaption');
            if (figcaption) {
                figcaption.classList.remove('show-mobile');
            }
        });
    });
});

